// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"a109420c","362":"9d428629","413":"314152a7","640":"86034139","688":"73d08567","787":"c8c08e53"}[chunkId] + ".chunk.js";
};